// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3MnmE","resendInfoText":"OnGoingPaymentBox_resendInfoText__qlzs4"};